import React, { useState } from 'react';
import { useAudio } from '../../providers/AudioContext';
import { StyledBroadsiderMenu } from './BroadsiderMenu.styled';

const BroadsiderMenuButton = ({ index, option, isSelected, onSelect, onHover, onUnhover, isHovered = false }) => {
  const { playSFX } = useAudio();
  const disabled = !!option.disabled;

  return (<div
    data-tutorial-anchor={`menu-button-${index}`}
    style={{backgroundColor: isSelected ? option.color : 'white', opacity: disabled ? '0.4': '1.0'}}
    onClick={() => {
      if (disabled) return;
      playSFX('menu_button');
      onSelect(option);
    }}
    className={`broadsider-menu-option${isSelected ? ' broadsider-menu-option-selected' : ''}`}
    onMouseEnter={() => {
      if (disabled) return;
      if (!isHovered) playSFX('hover');
      onHover(option);
    }}
    onMouseLeave={() => {
      if (disabled) return;
      onUnhover(option);
    }}>
    <img src={isHovered && !isSelected ? option.logoHover || option.logo: option.logo} className='broadsider-menu-option-icon' style={{scale: isHovered ? '1.2' : '1.0'}} />
  </div>);
};

const BroadsiderMenuListItem = ({ option, isSelected, color, onHover, onUnhover, onSelect }) => {
  const { playSFX } = useAudio();
  const disabled = !!option.disabled;

  return (
    <div className='broadsider-menu-list-item' style={{ opacity: disabled ? '0.4': '1.0' }}
      onClick={() => {
        if (disabled) return;
        playSFX('menu_button');
        onSelect(option);
      }}
      onMouseEnter={() => {
        if (disabled) return;
        if (!isSelected) playSFX('hover');
        onHover(option);
      }}
      onMouseLeave={() => {
        if (disabled) return;
        onUnhover(option);
      }} >
      <div className={`broadsider-menu-separator-vertical-short ${isSelected ? 'broadsider-menu-separator-vertical-wide' : ''}`} style={{backgroundColor: isSelected ? option.color : color}}/>
      <div className={`broadsider-menu-list-item-title${isSelected ? ' broadsider-menu-list-item-title-selected' : ''}`}>{option.title}</div>
    </div>
  );
};

const DUMMY_STRING = ' ';
const DUMMY_LOGO = '/assets/metaverse.svg';

const DUMMY_OPTION = {
  title: DUMMY_STRING,
  description: DUMMY_STRING,
  logo: DUMMY_LOGO
};

const BroadsiderMenu = ({ options, onSelect, selectedIndex = 0 }) => {
  const selectedOption = options.length >= selectedIndex + 1 ? options[selectedIndex] : DUMMY_OPTION;
  const [ hoveredIndex, setHoveredIndex ] = useState(null);
  const { title, descriptions, logo, color: selectedColor } = selectedOption;
  const [selectMode, setSelectMode] = useState(false);

  return (
    <StyledBroadsiderMenu
      $itemsCount={options.length}
      onMouseEnter={() => setSelectMode(true)}
      onMouseLeave={() => {
        setSelectMode(false);
        setHoveredIndex(null);
      }}>
      <div className='broadsider-menu-border' />
      <div className='broadsider-menu-contents'>
      <div className='broadsider-menu-button-holder'>
        {options.map((option, index) => {
          return (<BroadsiderMenuButton
            index={index}
            key={`menu-${index}`}
            option={option}
            isSelected={index === selectedIndex}
            onSelect={onSelect}
            isHovered={index === hoveredIndex}
            onUnhover={() => {}/*setHoveredIndex(null)*/}
            onHover={(o) => setHoveredIndex(options.findIndex((e) => e.title === o.title))}/>)
        })}
      </div>
      {!selectMode ? (<div className='broadsider-menu-info'>
        <div className='broadsider-menu-separator-vertical' style={{backgroundColor: selectedColor}}/>
        <div className='broadsider-menu-info-holder'>
          <h2 className='broadsider-menu-title'>
            {selectedOption.title}
	  </h2>
          <div className='broadsider-menu-separator-horizontal' style={{backgroundColor: selectedColor}}/>
          {selectedOption.descriptions.map((description, index) => (<div key={index} className='broadsider-menu-description'>{description}</div>))}
        </div>
      </div>) : (<div className='broadsider-menu-list-holder'>
        <div className='broadsider-menu-list'>
          {options.map((option, index) => {
            const isSelected = hoveredIndex === index;
            const hideSpacer = isSelected || hoveredIndex === index + 1;
            return (
	      <>
                <BroadsiderMenuListItem
                  key={`menu-list-${index}`}
                  option={option}
                  color={selectedColor}
                  onUnhover={() => {} /*setHoveredIndex(null)*/}
                  onHover={(o) => setHoveredIndex(options.findIndex((e) => e.title === o.title))}
                  onSelect={onSelect}
                  isSelected={isSelected} />
                {(index < options.length - 1) && (<div className='broadsider-menu-separator-vertical-spacer' style={{backgroundColor: hideSpacer ? 'transparent' : selectedColor}}/>)}
              </>
	    );
          })}
        </div>
      </div>)}
      </div>
    </StyledBroadsiderMenu>
  )
};

export default BroadsiderMenu;
